/** Idiomas del menú público (clientes finales). Dashboard permanece en español. */
export const CUSTOMER_LOCALES = [
  { code: 'es', label: 'Español', nativeLabel: 'Español', intl: 'es-CL', htmlLang: 'es-CL' },
  { code: 'en', label: 'English', nativeLabel: 'English', intl: 'en-US', htmlLang: 'en' },
  { code: 'pt', label: 'Português', nativeLabel: 'Português', intl: 'pt-BR', htmlLang: 'pt-BR' },
  { code: 'zh', label: '中文', nativeLabel: '中文', intl: 'zh-CN', htmlLang: 'zh-CN' },
  { code: 'de', label: 'Deutsch', nativeLabel: 'Deutsch', intl: 'de-DE', htmlLang: 'de' },
];

export const CUSTOMER_LOCALE_CODES = CUSTOMER_LOCALES.map((l) => l.code);
export const DEFAULT_CUSTOMER_LOCALE = 'es';
export const CUSTOMER_LANG_STORAGE_KEY = 'soluqr_customer_lang';

export function getCustomerLocaleMeta(code) {
  return CUSTOMER_LOCALES.find((l) => l.code === code) || CUSTOMER_LOCALES[0];
}

export function getIntlLocale(code = DEFAULT_CUSTOMER_LOCALE) {
  return getCustomerLocaleMeta(code).intl;
}

/** Detecta idioma preferido: ?lang= → localStorage → navigator → es */
export function detectCustomerLocale() {
  try {
    if (typeof window !== 'undefined') {
      const fromQuery = new URLSearchParams(window.location.search).get('lang');
      if (fromQuery) {
        const q = String(fromQuery).trim().toLowerCase().slice(0, 2);
        if (CUSTOMER_LOCALE_CODES.includes(q)) return q;
      }
      const stored = window.localStorage.getItem(CUSTOMER_LANG_STORAGE_KEY);
      if (stored && CUSTOMER_LOCALE_CODES.includes(stored)) return stored;
    }
  } catch {
    /* ignore */
  }

  // Jest/jsdom suele reportar en-US; los tests históricos esperan español.
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'test') {
    return DEFAULT_CUSTOMER_LOCALE;
  }

  try {
    const nav = typeof navigator !== 'undefined' ? navigator.language || navigator.languages?.[0] : '';
    const base = String(nav || '')
      .trim()
      .toLowerCase()
      .slice(0, 2);
    if (CUSTOMER_LOCALE_CODES.includes(base)) return base;
  } catch {
    /* ignore */
  }

  return DEFAULT_CUSTOMER_LOCALE;
}

export function persistCustomerLocale(code) {
  if (!CUSTOMER_LOCALE_CODES.includes(code)) return;
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(CUSTOMER_LANG_STORAGE_KEY, code);
    }
  } catch {
    /* ignore */
  }
  try {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = getCustomerLocaleMeta(code).htmlLang;
    }
  } catch {
    /* ignore */
  }
}
